import * as React from 'react';
import Pawn from './Pawn';
import './Box.css'
import { useDrop } from 'react-dnd';
import { ItemTypes } from './ItemTypes';

const Box = ({ boxId, game }) => {
    const [{ canDrop, isOver }, drop] = useDrop(
        () => ({
            accept: ItemTypes.PAWN,
            drop: () => game.movePawn(boxId),
            canDrop: () => game.canMovePawn(boxId),
            collect: (monitor) => ({
                canDrop: !!monitor.canDrop(),
                isOver: !!monitor.isOver()
            })
        }),
        [boxId]
    );

    return (
        <div className={`box ${canDrop ? 'selected' : ''} ${isOver ? 'dark' : ''}`} ref={drop}>
            {game.pawnContainer[boxId].length > 0 ? 
            <Pawn key={`pawn-${game.pawnContainer[boxId][0]}`} pawnId={game.pawnContainer[boxId][0]} game={game} /> : null}
        </div>
    );
}

export default Box;